export interface IMessageBase {
    Type: MessageType,
    ReceiverID: number
}

export interface IOrderInfo {
    OrderDoneSent: boolean | undefined,
    SortBoxes: Array<IRxSortBoxInfo>,
    CurrentSortBoxID: number,
    SortBoxID: number,
    OrderNumber: number,
    NotFound: boolean,
    NonRXOrder: boolean,
    BoxBarcode: string,
    ReleaseBox: boolean,
    Log: ILogItem[],
    SkuPutawayRequired: boolean,
}

export interface IBoxNotification {
    BoxBarcode: string,
    Queued: boolean,
    SortOrder: number,
    Type: string
}

export interface ILogItem {
    User: string,
    Message: string,
    BoxCancelleationReason: CancellationReason,
}

export interface IOrderInfoRequest {
    IPackBoxBarcode: string,
    WorkstationID: number
}

export interface IPurgeRequest {
    WorkstationID: number,
    BoxBarcode: string
}

export interface IRxSortBoxInfo {
    SortBoxID: number,
    Done: boolean,
    Snoozed: boolean,
    RxBagID: number,
    Cancelled: boolean
}

export interface IRxSortBoxItemUpdate {
    SkuID: number,
    quantity: number
}

export interface IRxSortBoxOrderUpdate {
    SortBoxID: number,
    Done: boolean
}

export interface IRXOperatorInfoModel {
    WorkstationID: number,
    OperatorID: number,
    LRX: boolean,
    LoggedIn: boolean,
    Paused: boolean,
    LoopTeamleader: boolean
}

export interface ISnoozeRequest {
    WorkstationID: number,
    RXSortBoxID: number
}

export interface IBoxCancellationRequest {
    WorkstationID: number,
    SortBoxID: number,
    CancellationReason: number,
    Comment: string,
    OperatorID: number,
    OrderNumber: number,
    RXBoxIDs: number[],
}

export enum MessageType {
    undefined = 0,
    LRXItemUpdate = 1, 
    LRXOrderFinished = 2,
    LRXOrderInfo = 3,
    BoxNotification = 6,
}

export enum CancellationReason {
    undefined = 0,
    NonRxOrderIncomplete = 1,
    NonRxOrderComplete = 2,
    RxOrderIncomplete = 3,
    RxOrderComplete = 4,
    OrderNotFound = 5,
    BoxRedirectToSupervisor = 6,
    BoxRedirectToCheckstation = 7,
    BoxRedirectToCheckstationCancelOrder = 8,
    BoxRedirectToCheckstationCancelDelivery = 9,
    BoxRedirectToCheckstationCancelOrderPartially = 10,
}